import   React                         ,
       { useState                      ,
	     useEffect                     }  from 'react';
import   classNames                       from 'classnames';

import   styles                           from './AdsCampaignList.module.scss';

import   AnimatedWaitingIcon2             from '../../widget/animations/animatedWaitingIcon2';
import   Trigger                          from '../../widget/actuators/Trigger';
import   ColumnTitle                      from '../../widget/dataDisplay/labels/ColumnTitle'
import   Window                           from '../../widget/windows/window';

import { LegalStructure     }  from '../../../dataTypes/legalStructureManagment/types';

import { Media                         ,
         MediaCategory                 }  from '../../../dataTypes/mediaManagment/types';
		 
import { Product                       ,
         ProductCategory               }  from '../../../dataTypes/productManagment/types';
		 
import { AdsCampaign                   }  from '../../../dataTypes/adsCampaignManagment/types';

import { getLegalStructures            }  from '../../../backendServices/legalStructureManagment/api_legalStructure';
import { getMediaList                  }  from '../../../backendServices/mediaManagment/api';
import { getMediaCategories            }  from '../../../backendServices/mediaManagment/api_category';
import { getProducts                   }  from '../../../backendServices/productManagment/api_product';
import { getProductCategories          }  from '../../../backendServices/productManagment/api_productCategory';

import { getAdsCampaigns             ,
         deleteAdsCampaign           }  from '../../../backendServices/adsCampaignManagment/api_adsCampaign';


import { useTypedSelector              }  from '../../../store/useTypeSelector';
import { RootState                     }  from '../../../store/generalReducer';

import   AdsCampaignRow                 from './AdsCampaignRow';
import   AdsCampaignSheet               from './AdsCampaignSheet';

export const AdsCampaignList = () => {

  const { authentication } = useTypedSelector((state: RootState) => state.authenticationReducer);

  const [ adsCampaignSet       , setAdsCampaignSet       ] = useState<AdsCampaign[]>([]);
  const [       , setAdsCampaignSet2      ] = useState<AdsCampaign[]>([]);

  const [ legalStructureSet    , setLegalStructureSet    ] = useState<LegalStructure[]>([]);
  const [              , setMediaSet             ] = useState<Media[]>([]);
  const [       , setMediaCategories      ] = useState<MediaCategory[]>([]);
  const [            , setProductSet           ] = useState<Product[]>([]);
  const [     , setProductCategories    ] = useState<ProductCategory[]>([]);

  const [ showWaitingIcon      , setShowWaitingIcon      ] = useState(false);

  const [     , setEditAdsCampaignId    ] = useState<number | null>(null);
  const [ editAdsCampaignIndex , setEditAdsCampaignIndex ] = useState<number | null>(null);
  const [ createNewAdsCampaign , setCreateNewAdsCampaign ] = useState<boolean>(false);
 
  const [ showMessageWindow    , setShowMessageWindow    ] = useState ( false );
  const [ message              , setMessage              ] = useState ( <></> );

  const [ showConfirmation     , setShowConfirmation     ] = useState (false);
  const [ adsCampaignToDelete  , setAdsCampaignToDelete  ] = useState<AdsCampaign | null>(null);

  useEffect(() => {

    const fetchData = async () => {

      try
       {
        setShowWaitingIcon(true);

        const [ legalStructuresResult   , 
		        mediasResult            , 
				mediaCategoriesResult   , 
				productsResult          , 
				productCategoriesResult , 
				adsCampaignResult       ] = await Promise.all ( [ getLegalStructures   () ,
                                                                  getMediaList         ([], authentication.admin?.id) ,
                                                                  getMediaCategories   () ,
                                                                  getProducts          (undefined, authentication.admin?.id) ,
                                                                  getProductCategories () ,
                                                                  getAdsCampaigns      () ] );

        if (legalStructuresResult.payload)
         {
          setLegalStructureSet (legalStructuresResult.payload);
         }

        if (mediasResult.payload)
         {
          setMediaSet (mediasResult.payload);
         }

        if (mediaCategoriesResult.payload)
         {
          setMediaCategories (mediaCategoriesResult.payload.sort((a, b) => a.rank - b.rank));
         }

        if (productsResult.payload)
         {
          setProductSet (productsResult.payload);
         }

        if (productCategoriesResult.payload)
         {
          setProductCategories (productCategoriesResult.payload.sort((a, b) => a.rank - b.rank));
         }

        if (adsCampaignResult.payload)
         {
          setAdsCampaignSet (adsCampaignResult.payload);
         }
       }
      catch (error)
       {
        console.error('Error fetching data:', error);
       }
      finally
       {
        setShowWaitingIcon(false);
       }
    };

    fetchData();
  }, []);

  useEffect(() => {

    console.log (adsCampaignSet)
  }, [adsCampaignSet]);
  
  const reinit = async () => {

    setShowWaitingIcon(true);
    const adsCampaignResult = await getAdsCampaigns();

    if (adsCampaignResult.payload) 
     {
      setAdsCampaignSet([...adsCampaignResult.payload]); 
     }

    setShowWaitingIcon(false);
  };

  const handleEditionClick = (index: number) => {
    setEditAdsCampaignId(adsCampaignSet[index].id); // Passer en mode carousel avec l'ID de la vidéo
    setEditAdsCampaignIndex(index); // Passer en mode carousel avec l'ID de la vidéo
  };

  const handleDeleteClick = (adsCampaign: AdsCampaign) => {

    setAdsCampaignToDelete (adsCampaign);
    setShowConfirmation(true);
  };

  const handleDeleteConfirmation = async (confirmed: boolean)=> {

    if ( confirmed && adsCampaignToDelete )
     {
      try
       {
        const response = await deleteAdsCampaign (adsCampaignToDelete.id);

        if (response.code === 1)
              {
               setAdsCampaignSet((prev) => prev.filter((adsCampaign) => adsCampaign.id !== adsCampaignToDelete.id));
               setAdsCampaignSet2((prev) => prev.filter((adsCampaign) => adsCampaign.id !== adsCampaignToDelete.id));
              // setMessage(<>La campagne de vente a été supprimée</>);
              }
         else {
               console.warn(`Impossible de supprimer la campagne de publicités ID ${adsCampaignToDelete.id} : ${response.comment}`);
               setMessage (
                           response.code === -103
                           ? <>Impossible de supprimer la campagne de publicités car elle est déjà liée à d'autres ressources</>
                           : <>Impossible de supprimer le campagne de publicités </>
                          );
               setShowMessageWindow(true);		  
              }
       }
      catch (error)
       {
        console.error(`Erreur lors de la suppression de la campagne ID ${adsCampaignToDelete.id}:`, error);
        setMessage(<>Impossible de supprimer la campagne de publicités</>);
        setShowMessageWindow(true);
       }
     }

    setShowConfirmation(false);
    setAdsCampaignToDelete(null);
  };


  const handleNewAdsCampaignCreationClick = () => {
    setCreateNewAdsCampaign (true)
  };

  const handleCreate = ( id: number ) => {

    setCreateNewAdsCampaign (false)
	setEditAdsCampaignIndex (null)
    reinit ()
  }

  const handleEdit = ( id: number ) => {

    setCreateNewAdsCampaign (false)
	setEditAdsCampaignIndex (null)
    reinit ()
  }


  const renderComponent = () : JSX.Element => {

    if ( createNewAdsCampaign )
          {
           // Est-ce qu'on affiche une fiche vierge pour créer une nouvelle campagne de ventes

           return <AdsCampaignSheet legalStructures      = {legalStructureSet}
                                    existingAdsCampaigns = {adsCampaignSet}
                                    onCreate             = {handleCreate}/>
          }
     else {
           if ( editAdsCampaignIndex !== null )
                 {
                  // Est-ce qu'on affiche la fiche d'une campagne existante pour édition

                  return <AdsCampaignSheet legalStructures      = {legalStructureSet}
		                                   existingAdsCampaigns = {adsCampaignSet}
                                           adsCampaign          = {adsCampaignSet[editAdsCampaignIndex]}
                                           onEdit               = {handleEdit} />
                 }
            else {
                  return (

                          <>

                            <div className={classNames(styles.upper_bar)}>

                               <div className={classNames(styles.upper_bar_right)}>
                                  <Trigger name    = "Créer une campagne"
                                           onClick = {handleNewAdsCampaignCreationClick}
                                           variant = "tailwind2"  />
                               </div>
                            </div>

                            <div className={classNames(styles.list_container)}>
                              <div className={classNames(styles.list)}>
                                 <ColumnTitle titles = {[ 'Index ' , 'Titre' , 'Date de début' , 'Date de fin'  , ''    , 'Actions' , 'Visibilité']}
                                              widths = {[ '50px  ' , 'auto'  , '150PX'         , '150px'        , '1px' , '159px'   , '80px'      ]} />
                                 {
                                  adsCampaignSet.map((adsCampaign, index) => (

                                    <AdsCampaignRow key                = {adsCampaign.id}
                                                    adsCampaign        = {adsCampaign}
                                                    index              = {index}
                                                    onEdit             = {handleEditionClick}
                                                    onDelete           = {handleDeleteClick}/>
                                   ))
                                 }
                              </div>
                            </div>

                          </>
                         )
                        }
                 }

  }

  const handleMessageWindowClose = () => {

    setShowMessageWindow (false)
  }

  return (
    <div className={classNames(styles.root)}>

      { showWaitingIcon && <AnimatedWaitingIcon2 /> }

      {
        showMessageWindow &&
        <Window message                 = {message}
                messageType             = "information"
                onClickOnValidateButton = {handleMessageWindowClose} 
				validButtonText         = "Ok"/>
      }

      {
        showConfirmation &&
        <Window message                 = {<>{`Êtes-vous sûr de vouloir supprimer la campagne de vente ${adsCampaignToDelete?.name} ?`}</>}
                messageType             = "question"
                onClickOnValidateButton = {() => handleDeleteConfirmation(true)}
                onClickOnCancelButton   = {() => handleDeleteConfirmation(false)} 
				validButtonText         = "Oui"
                cancelButtonText        = "Non"  />
      }

      { renderComponent () }

    </div>
  );
};

export default AdsCampaignList;
